import app from '../app.js';

const subscribeToTeacherChannel = ({ langId } = 1, cb) => {
  app.$echo.private(`teacher.lang.${langId}`).listen('RequestNotification', res => {
    cb(res);
  });
};

const subscribeToUserChannel = ({ userId }, cb) => {
  app.$echo.private(`user.${userId}`).listen('UserNotification', res => {
    cb(res);
  });
};

export { subscribeToTeacherChannel, subscribeToUserChannel };
